;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";import * as Sentry from "@sentry/nextjs"

Sentry.init({
  dsn: "https://9ababaec88548d83a70a8f8f54812a6e@data.playerdash.app/2",
  tracesSampleRate: 0,
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
